import { createContext } from 'react'
import { Position } from 'types'
import Renderer from './classes/renderer'
import Shader from './classes/shader'
import { ArtboardFilter } from './types'

type ArtboardContextProps = {
    crop?: Position
    frames: number
    filter?: ArtboardFilter
    filterIntensity?: number
    fps: number
    height: number
    paused: boolean
    renderer: Renderer | null
    shader: Shader | null
    width: number
}

export const ArtboardContext = createContext({} as ArtboardContextProps)
